const propAnalyzerConfig = {
    'wnba': true,
    'nfl': true,
    'cfb': false,
    'mlb': false,
    'nba': false,
    'nhl': false,
    'soccer': false,
    'ncaab': false,
    'mma': false,
}

export const canViewPropAnalyzer = (sportType) => {
    const normalizedSportType = String(sportType || '').toLowerCase() === 'ncaabb' ? 'ncaab' : String(sportType || '').toLowerCase();
    return propAnalyzerConfig[normalizedSportType];
}
